import {
  Report,
  List as ListIcon,
  Share,
  Coin,
  User as UserIcon,
  Cs,
  InfoInfo,
  Logout,
  InfoQuestion,
  AiLine,
  PressGift,
  PressCard,
} from "../../../assets/svgs/icons";
import { useMyAirView } from "../hooks/presentation/useMyAirView";
import List from "../../../components/list";
import { useContext } from "react";
import { MyContext } from "../../../context/MyContext";

const MyAirV2Content = () => {
  const { isAppMode, isUnderVersion } = useContext(MyContext);

  const {
    isPressCardValid,
    handleActivityClick,
    handlePersonaClick,
    handleOrderClick,
    handleGuideClick,
    handleShareClick,
    handleProductsClick,
    handleMypageClick,
    handlePressCardClick,
    handleCSClick,
    handleCompanyClick,
    handleTestPageClick,
    handleLogout,
  } = useMyAirView();

  return (
    <>
      <div className="flex items-start w-full mb-2">
        <div
          className="flex-1 box-border flex flex-col gap-3 items-center justify-center p-4 h-21 cursor-pointer transition-colors hover:bg-[#f7f7f7] rounded-lg"
          onClick={handleActivityClick}
        >
          <Report width={20} height={20} className="text-[#212121]" />
          <span className="font-medium text-[#212121] text-[14px] tracking-[-0.28px] leading-5 whitespace-nowrap">
            나의 활동
          </span>
        </div>
        <div
          className="flex-1 box-border flex flex-col gap-3 items-center justify-center p-4 h-21 cursor-pointer transition-colors hover:bg-[#f7f7f7] rounded-lg"
          onClick={handlePersonaClick}
        >
          <AiLine width={20} height={20} className="text-[#212121]" />
          <span className="font-medium text-[#212121] text-[14px] tracking-[-0.28px] leading-5 whitespace-nowrap">
            어투 설정
          </span>
        </div>
        <div
          className="flex-1 box-border flex flex-col gap-3 items-center justify-center p-4 h-21 cursor-pointer transition-colors hover:bg-[#f7f7f7] rounded-lg"
          onClick={handleOrderClick}
        >
          <ListIcon width={20} height={20} className="text-[#212121]" />
          <span className="font-medium text-[#212121] text-[14px] tracking-[-0.28px] leading-5 whitespace-nowrap">
            이용 내역
          </span>
        </div>
      </div>
      <div className="w-full">
        {/* 임시 조치 app에서 안나오게 수정 */}
        {(!isAppMode || isUnderVersion) && (
          <List
            icon={<InfoQuestion className="w-5 h-5" />}
            label="이용 가이드"
            style="horizontal"
            type="link"
            onClick={handleGuideClick}
          />
        )}
        <List
          icon={<Share className="w-5 h-5" />}
          label="공유 목록"
          style="horizontal"
          type="link"
          onClick={handleShareClick}
        />
        <List
          icon={<Coin className="w-5 h-5" />}
          label="구독 상품"
          style="horizontal"
          type="link"
          onClick={handleProductsClick}
        />
        {/* <List
          icon={<Coin className="w-5 h-5" />}
          label="구독 상품 테스트 페이지"
          style="horizontal"
          type="link"
          onClick={handleTestPageClick}
        /> */}
        {/* 임시 조치 app에서 안나오게 수정 */}
        {(!isAppMode || isUnderVersion) && (
          <List
            icon={<UserIcon className="w-5 h-5" />}
            label="통합 마이페이지"
            style="horizontal"
            type="link"
            onClick={handleMypageClick}
          />
        )}
        {/* 어린이 기자단 기자증 — 모든 유저 상시 노출 */}
        {/* 발급 완료+유효: 기자증(card) 아이콘 + "나의 기자증 확인하기" */}
        {/* 그 외        : 혜택(gift) 아이콘 + "어린이 기자단 혜택 받기" */}
        <List
          icon={
            isPressCardValid ? (
              <PressCard className="w-5 h-5" />
            ) : (
              <PressGift className="w-5 h-5" />
            )
          }
          label={
            isPressCardValid ? "나의 기자증 확인하기" : "어린이 기자단 혜택 받기"
          }
          style="horizontal"
          type="link"
          onClick={handlePressCardClick}
        />
        <List
          icon={<Cs className="w-5 h-5" />}
          label="고객 센터"
          style="horizontal"
          type="link"
          onClick={handleCSClick}
        />
        <List
          icon={<InfoInfo className="w-5 h-5" />}
          label="회사 정보"
          style="horizontal"
          type="link"
          onClick={handleCompanyClick}
        />
      </div>
      <div className="flex-1" />

      {/* 이용권 등록 카드 */}
      <div className="w-full px-4 py-4">
        <div className="rounded-[8px] p-[1px] bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa]">
          <div className="rounded-[7px] flex items-center justify-between px-4 py-2 h-[54px] bg-white">
            <span className="font-bold text-[16px] tracking-[-0.32px] bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] bg-clip-text text-transparent">
              이미 이용권이 있다면?
            </span>
            <button
              onClick={() =>
                window.open(
                  "https://my.dongascience.com/rewards/coupon",
                  "_blank",
                )
              }
              className="font-medium text-[#888] text-[14px] tracking-[-0.28px] underline"
            >
              등록하기
            </button>
          </div>
        </div>
      </div>

      {/* Logout */}
      <div className="w-full" style={{ borderTop: "1px solid #eeeeee" }}>
        <div
          className="flex items-center min-h-[52px] pl-4 pr-0 py-0 gap-2 cursor-pointer transition-colors hover:bg-[#f7f7f7] rounded-lg"
          onClick={handleLogout}
        >
          <Logout width={20} height={20} className="text-[#666666]" />
          <span className="font-medium text-[#666666] text-[14px] tracking-[-0.28px] leading-5">
            로그아웃
          </span>
        </div>
      </div>
    </>
  );
};

export default MyAirV2Content;
